import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    schoolClientsFilter: {
        search: "",
        division: "",
        school: "",
        status: { label: "Active", value: "active" },
        grade: "",
        sort: {
            column: "lastname",
            direction: "asc"
        }
    },
    homeEducationClientsFilter: {
        search: "",
        education_authority: "",
        source: "",
        status: { label: "Active", value: "active" },
        startDate: "",
        endDate: "",
        sort: {
            column: "lastname",
            direction: "asc"
        }
    },
    chatterClientsFilter: {
        search: "",
        funding_source: "",
        status: { label: "Active", value: "active" },
        sort: {
            column: "lastname",
            direction: "asc"
        }
    },
    privateClientsFilter: {
        search: "",
        status: "active",
        start_date: "",
        end_date: "",
        sort: {
            column: "lastname",
            direction: "asc"
        }
    },
    clientsManageStatusFilter: {
        search: "",
        module: "client_service",
        client_type: "school",
        status: "",
        sort: {
            column: "title",
            direction: "asc"
        }
    },
    therapistProfilesFilter: {
        search: "",
        status: { label: "Active", value: "active" },
        type: "",
        sort: {
            column: "lastname",
            direction: "asc",
        },
    },
    schoolProfilesFilter: {
        search: "",
        status: "active",
        division: "",
        sort: {
            column: "name",
            direction: "asc"
        }
    },
    schoolDivisionsFilter: {
        search: "",
        status: "active",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    appointmentServicesFilter: {
        search: "",
        status: "active",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    chatterProgramProfilesFilter: {
        search: "",
        status: "active",
        sort: {
            column: "name",
            direction: "asc"
        }
    },
    chatterLessonPlansFilter: {
        search: "",
        status: "active",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    chatterPeersFilter: {
        search: "",
        status: "active",
        program_id: "",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    disciplinesFilter: {
        search: "",
        status: "",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    usersFilter: {
        search: "",
        role: 2,
        status: "active",
        sort: {
            column: "lastname",
            direction: "asc"
        }
    },
    goalsFilter: {
        search: "",
        discipline_id: "",
        discipline_area: "",
        sort: {
            column: "title",
            direction: "asc"
        }
    },
    fundingSourceFilter: {
        search: "",
        status: "active",
        sort: {
            column: "name",
            direction: "asc"
        }
    },
    mdtFilter: {
        search: "",
        client_type: "",
        specialization: "",
        status: "active",
        mdtStatus: "",
        startDate: "",
        endDate: "",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    cmsFilter: {
        search: "",
        status: "active",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    parentsFilter: {
        search: "",
        status: "active",
        role: 5,
        sort: {
            column: "lastname",
            direction: "asc"
        }
    },
    teachersFilter: {
        search: "",
        status: "active",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    coordinatorsFilter: {
        search: "",
        status: { value: 'active', label: 'Active' },
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    supportStaffFilter: {
        search: "",
        division: "",
        school: "",
        client_type: "",
        status: { label: "Active", value: "active" },
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    designationsFilter: {
        search: "",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    serviceStatusFilter: {
        search: "",
        module: "service",
        client_type: "",
        status: "",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    exportFilter: {
        status: "",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    consentFormFilter: {
        search: "",
        status: "active",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    appointmentsFilter: {
        search: "",
        status: "active",
        type: "",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    appointmentInvoicesFilter: {
        search: "",
        status: "",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    assessmentTemplatesFilter: {
        search: "",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    chatterTemplatesFilter: {
        search: "",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    auditLogsFilter: {
        search: "",
        event_type: "",
        start_date: "",
        end_date: "",
        panel: "",
        sort: {
            column: "createdAt",
            direction: "desc"
        }
    },
    notesFilter: {
        search: "",
        date: "",
        owner: "",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    noteCommentsFilter: {
        search: "",
        date: "",
        owner: "",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    schoolBannerFilter: {
        search: "",
        status: "",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    notificationsFilter: {
        category: "notification", // notification, action_item
        type: "",
        isArchived: { label: "Active", value: false },
        isRead: null,
        isCompleted: null,
        sort: {
            date: "desc"
        },
    },
    userNotificationsFilter: {
        category: "notification", // notification, action_item
        type: "",
        isRead: null,
        isCompleted: null,
        sort: {
            date: "desc"
        },
    },
}

const filterSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        schoolClientsFilter: (state, action) => {
            const filter = action.payload;
            state.schoolClientsFilter = filter;
        },
        homeEducationClientsFilter: (state, action) => {
            const filter = action.payload;
            state.homeEducationClientsFilter = filter;
        },
        chatterClientsFilter: (state, action) => {
            const filter = action.payload;
            state.chatterClientsFilter = filter;
        },
        privateClientsFilter: (state, action) => {
            const filter = action.payload;
            state.privateClientsFilter = filter;
        },
        clientsManageStatusFilter: (state, action) => {
            const filter = action.payload;
            state.clientsManageStatusFilter = filter;
        },
        therapistProfilesFilter: (state, action) => {
            const filter = action.payload;
            state.therapistProfilesFilter = filter;
        },
        schoolProfilesFilter: (state, action) => {
            const filter = action.payload;
            state.schoolProfilesFilter = filter;
        },
        schoolDivisionsFilter: (state, action) => {
            const filter = action.payload;
            state.schoolDivisionsFilter = filter;
        },
        appointmentServicesFilter: (state, action) => {
            const filter = action.payload;
            state.appointmentServicesFilter = filter;
        },
        chatterProgramProfilesFilter: (state, action) => {
            const filter = action.payload;
            state.chatterProgramProfilesFilter = filter;
        },
        chatterLessonPlansFilter: (state, action) => {
            const filter = action.payload;
            state.chatterLessonPlansFilter = filter;
        },
        chatterPeersFilter: (state, action) => {
            const filter = action.payload;
            state.chatterPeersFilter = filter;
        },
        disciplinesFilter: (state, action) => {
            const filter = action.payload;
            state.disciplinesFilter = filter;
        },
        usersFilter: (state, action) => {
            const filter = action.payload;
            state.usersFilter = filter;
        },
        goalsFilter: (state, action) => {
            const filter = action.payload;
            state.goalsFilter = filter;
        },
        fundingSourceFilter: (state, action) => {
            const filter = action.payload;
            state.fundingSourceFilter = filter;
        },
        mdtFilter: (state, action) => {
            const filter = action.payload;
            state.mdtFilter = filter;
        },
        cmsFilter: (state, action) => {
            const filter = action.payload;
            state.cmsFilter = filter;
        },
        parentsFilter: (state, action) => {
            const filter = action.payload;
            state.parentsFilter = filter;
        },
        teachersFilter: (state, action) => {
            const filter = action.payload;
            state.teachersFilter = filter;
        },
        coordinatorsFilter: (state, action) => {
            const filter = action.payload;
            state.coordinatorsFilter = filter;
        },
        supportStaffFilter: (state, action) => {
            const filter = action.payload;
            state.supportStaffFilter = filter;
        },
        designationsFilter: (state, action) => {
            const filter = action.payload;
            state.designationsFilter = filter;
        },
        serviceStatusFilter: (state, action) => {
            const filter = action.payload;
            state.serviceStatusFilter = filter;
        },
        exportFilter: (state, action) => {
            const filter = action.payload;
            state.exportFilter = filter;
        },
        consentFormFilter: (state, action) => {
            const filter = action.payload;
            state.consentFormFilter = filter;
        },
        appointmentsFilter: (state, action) => {
            const filter = action.payload;
            state.appointmentsFilter = filter;
        },
        appointmentInvoicesFilter: (state, action) => {
            const filter = action.payload;
            state.appointmentInvoicesFilter = filter;
        },
        assessmentTemplatesFilter: (state, action) => {
            const filter = action.payload;
            state.assessmentTemplatesFilter = filter;
        },
        chatterTemplatesFilter: (state, action) => {
            const filter = action.payload;
            state.chatterTemplatesFilter = filter;
        },
        auditLogsFilter: (state, action) => {
            const filter = action.payload;
            state.auditLogsFilter = filter;
        },
        notesFilter: (state, action) => {
            const filter = action.payload;
            state.notesFilter = filter;
        },
        noteCommentsFilter: (state, action) => {
            const filter = action.payload;
            state.noteCommentsFilter = filter;
        },
        schoolBannerFilter: (state, action) => {
            const filter = action.payload;
            state.schoolBannerFilter = filter;
        },
        notificationsFilter: (state, action) => {
            const filter = action.payload;
            state.notificationsFilter = filter;
        },
        userNotificationsFilter: (state, action) => {
            const filter = action.payload;
            state.userNotificationsFilter = filter;
        },
    },
});

export const {
    schoolClientsFilter,
    homeEducationClientsFilter,
    chatterClientsFilter,
    privateClientsFilter,
    clientsManageStatusFilter,
    therapistProfilesFilter,
    schoolProfilesFilter,
    schoolDivisionsFilter,
    chatterProgramProfilesFilter,
    chatterLessonPlansFilter,
    chatterPeersFilter,
    disciplinesFilter,
    usersFilter,
    goalsFilter,
    fundingSourceFilter,
    mdtFilter,
    cmsFilter,
    parentsFilter,
    teachersFilter,
    supportStaffFilter,
    designationsFilter,
    serviceStatusFilter,
    exportFilter,
    consentFormFilter,
    appointmentsFilter,
    appointmentServicesFilter,
    appointmentInvoicesFilter,
    assessmentTemplatesFilter,
    chatterTemplatesFilter,
    auditLogsFilter,
    notesFilter,
    noteCommentsFilter,
    schoolBannerFilter,
    coordinatorsFilter,
    notificationsFilter,
    userNotificationsFilter
} = filterSlice.actions;

export default filterSlice.reducer;
